import {
  Box,
  Typography,
  InputAdornment,
  IconButton,
  Button,
  TextField
} from '@mui/material'
import React, { Fragment, SyntheticEvent, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import { useApi } from '../../../hooks/useApi'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { useSnackbar } from '../../../hooks/useSnackbar'
import { Status } from '../../../hooks/useFetchState'
import { SnackBar } from '../../../components/SnackBar/Snackbar'
import { AsnReceiveFilters, AsnToReceive } from '../Interfaces'
import { getAsnToReceive } from '../api'
import { NextSteps } from './NextSteps'
import { useStyles } from '../styles'
import { stepEnum } from '../enum'

interface AsnSearchProps {
  controls: StepperControls
}

export const AsnSearch: React.FC<AsnSearchProps> = ({ controls }) => {
  const classes = useStyles()
  const { callApi, state } = useApi<AsnToReceive[]>()
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()
  const [asnNumber, setAsnNumber] = useState('')
  const isDisabledButton =
    asnNumber.length === 0 || state.status === Status.Loading

  const requestAsnToReceive = () => {
    const filters: AsnReceiveFilters = { asnNumber: asnNumber }
    callApi(getAsnToReceive(filters))
      .then((response: AsnToReceive[]) => {
        if (response.length > 1) {
          controls.goToStep(stepEnum.asnSelection, filters)
        } else {
          controls.goToNextStep()
        }
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
  }

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    requestAsnToReceive()
  }

  return (
    <Fragment>
      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
      >
        <Typography variant='h6'>Recepción de LPN</Typography>
      </Box>
      <div className={classes.flexContainer}>
        {controls.currentStep === stepEnum.asnSearch && (
          <div>
            <Box
              component='div'
              display='flex'
              flexDirection='row'
              flexWrap='nowrap'
              alignItems='left'
              padding='10px 20px 0 20px'
            >
              <Typography
                variant='h6'
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  marginTop: '30px'
                }}
              >
                Ingrese ASN
              </Typography>
            </Box>
            <form
              onSubmit={(e) => {
                handleSubmit(e)
              }}
            >
              <Box
                component='div'
                display='flex'
                flexDirection='row'
                flexWrap='nowrap'
                alignItems='center'
                padding='10px 10px 0 10px'
                style={{ width: '300px' }}
              >
                <TextField
                  id='searchValue'
                  name='searchValue'
                  value={asnNumber}
                  type='text'
                  onChange={(e) => {
                    setAsnNumber(e.target.value)
                  }}
                  variant='outlined'
                  fullWidth
                  label='Ingresar/Escanear ID'
                  autoFocus
                  autoComplete='off'
                  InputProps={{
                    endAdornment: asnNumber.length > 0 && (
                      <InputAdornment position='end'>
                        <IconButton onClick={() => setAsnNumber('')}>
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  style={{ left: '7px' }}
                />
              </Box>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'center',
                  width: '300px'
                }}
              >
                <span
                  onClick={() => {
                    controls.goToStep(6)
                  }}
                  style={{
                    textDecoration: 'underline',
                    color: 'blue',
                    cursor: 'pointer'
                  }}
                >
                  <Typography>Desconozco el id</Typography>
                </span>
              </div>
              <Box
                component='div'
                display='flex'
                flexDirection='row'
                flexWrap='nowrap'
                alignItems='center'
                padding='5px 10px'
              >
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='primary'
                  style={{
                    marginTop: '20px',
                    width: '90%',
                    minWidth: '90%',
                    left: '10px'
                  }}
                  disabled={isDisabledButton}
                >
                  Siguiente
                </Button>
              </Box>
            </form>
          </div>
        )}
        {controls.currentStep > 0 && (
          <NextSteps
            controls={controls}
            asnNumber={asnNumber}
            getAsnSummary={getAsnToReceive}
            openSnackBar={openSnackBar}
          />
        )}
        <SnackBar
          message={message}
          open={isActive}
          status={isSuccess ? 'success' : 'error'}
        />
      </div>
    </Fragment>
  )
}
